class CartSellingPlanSelector extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', (e) => {
      if (!e.target.matches('.selling-plan-select')) return;
      this.onSellingPlanChange(e);
    });
  }

  connectedCallback() {
    this.discount = Number(this.dataset.discount || 0);
    this.select = this.querySelector('.selling-plan-select');

    // Initialize UI on load
    //requestAnimationFrame(() => this.initializePricing());

    // Auto-select first plan when opening details
    const details = this.closest('details');
    if (details) {
      const summaryBtn = details.querySelector('summary');
      summaryBtn?.addEventListener('click', () => this.selectFirstSellingPlan());
    }
  }

  initializePricing() {
    if (!this.select) return;

    const hasPlan = this.select.value !== "";

    if (hasPlan) {
      this.applyDiscountUI();
    } else {
      this.resetPricingUI();
    }
  }

  applyDiscountUI() {
  if (!this.discount) return;

  const cartItem = this.closest('.cart-item');
  if (!cartItem) return;

  const priceWrapper = cartItem.querySelector('.cart-item__price-wrapper .price');
  if (!priceWrapper) return;

  const raw = priceWrapper.textContent.replace(/[^0-9.]/g, '');
  const base = Number(raw);
  const discounted = base - (base * (this.discount / 100));

  // Build sale markup
  const saleHTML = `
    <span class="price price--on-sale">
      <span class="price-original">
        <s class="price-item price-item--regular">
          $${base.toFixed(2)}
        </s>
      </span>
      <span class="price__sale">
        <span class="price-item price-item--sale price-item--last">
          $${discounted.toFixed(2)}
        </span>
      </span>
    </span>
  `;

  priceWrapper.innerHTML = saleHTML;
}


  resetPricingUI() {
  const cartItem = this.closest('.cart-item');
  if (!cartItem) return;

  const priceWrapper = cartItem.querySelector('.cart-item__price-wrapper .price');
  if (!priceWrapper) return;

  const raw = priceWrapper.textContent.replace(/[^0-9.]/g, '');
  const base = Number(raw);

  priceWrapper.innerHTML = `$${base.toFixed(2)}`;
}


  async onSellingPlanChange(e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();

    const line = Number(e.target.dataset.line);
    const sellingPlanId = e.target.value === '' ? null : Number(e.target.value);

    const cart = await fetch('/cart.js').then(r => r.json());
    const item = cart.items[line - 1];
    if (!item) return;

    const quantity = item.quantity;

    const cartItems = document.querySelector('cart-items') ||
                      document.querySelector('cart-drawer-items');
    cartItems?.enableLoading(line);

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line,
        quantity,
        selling_plan: sellingPlanId,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });

    const parsedState = await response.json();

    if (parsedState.sections) {
      const drawer = document.querySelector('cart-drawer');
      drawer?.renderContents(parsedState);
    }

    cartItems?.disableLoading();
  }

  selectFirstSellingPlan() {
    const select = this.querySelector('.selling-plan-select');
    if (!select) return;

    if (select.value && select.value !== '') return;

    const firstSubscription = [...select.options].find(opt => opt.value !== '');
    if (!firstSubscription) return;

    select.value = firstSubscription.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('bd-selling-plan-selector', CartSellingPlanSelector);
